import React from "react";
import ReactDOM from "react-dom";
import { Route } from "react-router";
import { BrowserRouter, Switch } from "react-router-dom";

import { AuthenticationProvider } from "@authentication";
import { PrivacyPolicy } from "@pages/PrivacyPolicy/PrivacyPolicy";
import { PrivacyPolicyAr } from "@pages/PrivacyPolicy/PrivacyPolicyAr";
import { PrivacyPolicyEs } from "@pages/PrivacyPolicy/PrivacyPolicyEs";
import { PrivacyPolicyFr } from "@pages/PrivacyPolicy/PrivacyPolicyFr";
import { PrivacyPolicyIt } from "@pages/PrivacyPolicy/PrivacyPolicyIt";
import { PrivacyPolicyRu } from "@pages/PrivacyPolicy/PrivacyPolicyRu";
import { TermsAndConditions } from "@pages/TermsAndConditions/TermsAndConditions";
import { TermsAndConditionsAr } from "@pages/TermsAndConditions/TermsAndConditionsAr";
import { TermsAndConditionsEs } from "@pages/TermsAndConditions/TermsAndConditionsEs";
import { TermsAndConditionsIt } from "@pages/TermsAndConditions/TermsAndConditionsIt";
import { TermsAndConditionsRu } from "@pages/TermsAndConditions/TermsAndConditionsRu";
import { TermsAndConditionsFr } from "@pages/TermsAndConditions/TernsAndConditionsFr";
import App from "./App";

import "@styles";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route exact path="/privacy-policy">
          <PrivacyPolicy />
        </Route>
        <Route exact path="/terms-and-conditions">
          <TermsAndConditions />
        </Route>
        <Route exact path="/privacy-policy/ru">
          <PrivacyPolicyRu />
        </Route>
        <Route exact path="/terms-and-conditions/ru">
          <TermsAndConditionsRu />
        </Route>
        <Route exact path="/privacy-policy/fr">
          <PrivacyPolicyFr />
        </Route>
        <Route exact path="/terms-and-conditions/fr">
          <TermsAndConditionsFr />
        </Route>
        <Route exact path="/privacy-policy/es">
          <PrivacyPolicyEs />
        </Route>
        <Route exact path="/terms-and-conditions/es">
          <TermsAndConditionsEs />
        </Route>
        <Route exact path="/privacy-policy/ar">
          <PrivacyPolicyAr />
        </Route>
        <Route exact path="/terms-and-conditions/ar">
          <TermsAndConditionsAr />
        </Route>
        <Route exact path="/privacy-policy/it">
          <PrivacyPolicyIt />
        </Route>
        <Route exact path="/terms-and-conditions/it">
          <TermsAndConditionsIt />
        </Route>
        <Route path="/">
          <AuthenticationProvider>
            <App />
          </AuthenticationProvider>
        </Route>
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
